import {createContext, useContext} from 'react'

/**
 * Signals whether the shift-events feature is rendered on the legacy blue
 * primary surface (Cockpit) rather than the Suite light/dark page surface.
 *
 * Header controls (tab toggle, filter bar) use token-based colours
 * (`text.primary`, `divider`, ...). On the blue surface those must resolve to
 * the on-blue contrast colours, which the `FilterContrastProvider` handles when
 * this context is `true`. Suite keeps the default (`false`) so the ambient
 * light/dark theme resolves the same tokens correctly.
 */
const InvertedSurfaceContext = createContext(false)

export const InvertedSurfaceProvider = InvertedSurfaceContext.Provider

export const useInvertedSurface = (): boolean => useContext(InvertedSurfaceContext)
